"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _textInputModule = _interopRequireDefault(require("./textInput.module.css"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _searchIcon = _interopRequireDefault(require("../icons/searchIcon"));

var _loader = _interopRequireDefault(require("../loader/loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextLoader = function TextLoader(props) {
  var isLoading = props.isLoading,
      id = props.id;
  return _react.default.createElement(_react.default.Fragment, null, isLoading && _react.default.createElement(_loader.default, {
    id: id ? "".concat(id, "_loader") : null,
    variant: "dots"
  }));
};

var TextInput = function TextInput(props) {
  var id = props.id,
      onChange = props.onChange,
      value = props.value,
      name = props.name,
      disabled = props.disabled,
      required = props.required,
      onBlur = props.onBlur,
      withIcon = props.withIcon,
      icon = props.icon,
      type = props.type,
      autoComplete = props.autoComplete,
      placeholder = props.placeholder,
      isLoading = props.isLoading;
  return _react.default.createElement(_react.default.Fragment, null, withIcon && _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, _textInputModule.default["buttonPickerWrapper"])
  }, _react.default.createElement("input", {
    id: id ? "".concat(id, "_input") : null,
    autoComplete: autoComplete ? autoComplete : "",
    className: (0, _classnames.default)(_themeModule.default.arag, _textInputModule.default["form-control"]),
    value: value,
    name: name,
    onChange: onChange,
    onBlur: onBlur,
    disabled: disabled,
    required: required,
    type: type ? type : 'text',
    placeholder: placeholder
  }), icon ? _react.default.createElement("button", {
    id: id ? "".concat(id, "_input_button") : null,
    className: (0, _classnames.default)(_textInputModule.default["btn"], _textInputModule.default["form-control"], _textInputModule.default["buttonPicker"]),
    tabIndex: -1
  }, icon) : _react.default.createElement("button", {
    id: id ? "".concat(id, "_input_button") : null,
    className: (0, _classnames.default)(_textInputModule.default["btn"], _textInputModule.default["form-control"], _textInputModule.default["buttonPicker"]),
    tabIndex: -1
  }, _react.default.createElement(_searchIcon.default, {
    id: id ? "".concat(id, "_input_button_icon") : null,
    className: _textInputModule.default["icon-search"]
  })), _react.default.createElement(TextLoader, {
    isLoading: isLoading,
    id: id
  })), !withIcon && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("input", {
    id: id ? "".concat(id, "_input") : null,
    autoComplete: autoComplete ? autoComplete : "",
    className: (0, _classnames.default)(_themeModule.default.arag, _textInputModule.default["form-control"]),
    value: value,
    name: name,
    onChange: onChange,
    onBlur: onBlur,
    disabled: disabled,
    required: required,
    placeholder: placeholder,
    type: type ? type : 'text'
  }), _react.default.createElement(TextLoader, {
    isLoading: isLoading,
    id: id
  })));
};

TextInput.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String text that enables or disable the browser to offer autocompletion */
  autoComplete: _propTypes.default.string,

  /** Callback invoked on blur. An event argument will be available. eg: (evt) => {} */
  onBlur: _propTypes.default.func,

  /** Callback invoked when the input changes.It will be passed with an event argument as an argument.eg: (evt) =>{} */
  onChange: _propTypes.default.func.isRequired,

  /** The name attribute of the element */
  name: _propTypes.default.string.isRequired,

  /** The value of the input */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,

  /** Boolean indicating if the component is disabled  */
  disabled: _propTypes.default.bool,

  /** Boolean indicating if the component is required  */
  required: _propTypes.default.bool,

  /** Boolean indicating if the text input component should have an icon at the end  */
  withIcon: _propTypes.default.bool,

  /** String that specifies the type of the input  */
  type: _propTypes.default.string,

  /** String that specifies the placeholder of the input  */
  placeholder: _propTypes.default.string,

  /** Loading while fetching data from the end point  */
  isLoading: _propTypes.default.bool
};
var _default = TextInput;
exports.default = _default;